"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateCashflow = exports.calculateDistributionSurplus = exports.preparedCashFlowTable = exports.CashFlowTable = void 0;
const zod_1 = require("zod");
exports.CashFlowTable = zod_1.z
    .array(zod_1.z.object({
    date: zod_1.z.coerce.date(),
    assetValueDevelopment: zod_1.z.number(),
    rentalSurplusIndexed: zod_1.z.number(),
    loanBalance: zod_1.z.number(),
    interest: zod_1.z.number(),
    repayment: zod_1.z.number(),
    fees: zod_1.z.number(),
    distributionSurplus: zod_1.z.number().optional(),
    cashFlow: zod_1.z.number().optional(),
}))
    .transform((data) => {
    return data.map((tableRow) => {
        return {
            ...tableRow,
            distributionSurplus: calculateDistributionSurplus(tableRow),
            cashFlow: calculateCashflow(tableRow),
        };
    });
});
exports.preparedCashFlowTable = zod_1.z.object({
    preparedCashFlowTable: exports.CashFlowTable,
    distributionSurplusSum: zod_1.z.number().optional().nullable(),
});
/**
 * Sometimes called "Ausschüttungsüberschuss", this is the distribution surplus.
 * @param CashFlowTable the cashflow table row
 * @returns distributionSurplus as money.
 */
function calculateDistributionSurplus({ rentalSurplusIndexed, interest, fees }) {
    return twoDecimals(rentalSurplusIndexed - interest - fees);
}
exports.calculateDistributionSurplus = calculateDistributionSurplus;
/**
 * This returns the cashflow for a given row in the cashflow table. The last row (ie. when the credit expires / the property is sold) is treated differently.
 * @param CashFlowTable the cashflow table row
 * @param index index of the row in the cashflow table
 * @param tableLength length of the cashflow table
 * @returns cashflow in money.
 */
function calculateCashflow({ rentalSurplusIndexed, interest, repayment, fees }) {
    return twoDecimals(rentalSurplusIndexed - interest - repayment - fees);
}
exports.calculateCashflow = calculateCashflow;
function twoDecimals(number) {
    return Math.round(number * 100) / 100;
}
//# sourceMappingURL=index.js.map